import { render, staticRenderFns } from "./EmptyInbox.vue?vue&type=template&id=fdcca050&scoped=true&"
import script from "./EmptyInbox.vue?vue&type=script&lang=ts&"
export * from "./EmptyInbox.vue?vue&type=script&lang=ts&"
import style0 from "./EmptyInbox.vue?vue&type=style&index=0&id=fdcca050&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdcca050",
  null
  
)

export default component.exports